export class RouteParams {
    public static DebtorKey = ':debtorKey';
    public static InvoiceNumber = ':invoiceNumber';
    public static InvoiceKey = ':invoiceKey';
    public static FundingBatchKey = ':fundingBatchKey';
    public static GroupedInvoiceKey = ':groupedInvoiceKey';
    public static FormKey = ':formKey';
    public static PlatformId = ':platformId';
    public static RelationshipKey = ':relationshipKey';
    public static BuyerKey = ':buyerKey';
    public static SellerKey = ':sellerKey';
    public static ProspectId = ':prospectId';
    public static EarlyPaymentKey = ':earlyPaymentKey';
    public static PendingGroupId = ':pendingGroupId';
    public static ReportId = ':reportId';
    public static CompanyRoleId = ':companyRoleId';
    public static CompanyKey = ':companyKey';
}
